import React, { useContext } from "react";
import "./Services.css";
import Card from "../Card/Card";
import HeartEmoji from "../../img/heartemoji.png";
import Glasses from "../../img/glasses.png";
import Humble from "../../img/humble.png";
import { themeContext } from "../../Context";
import { motion } from "framer-motion";
import Resume from './Resume.pdf';

const Services = () => {
  // context
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  // transition
  const transition = {
    duration: 1,
    type: "spring",
  };

  return (
    <div className="services" id="services">
      {/* left side */}
      <div className="awesome">
        {/* dark mode */}
        <span style={{ color: darkMode ? "white" : "" }}>My Awesome</span>
        <span>services</span>
        <span>
        I specialize in creating visually stunning and user-friendly websites 
          <br />
          that are tailored to meet the unique needs of businesses and individuals,
          <br />
          by combining my expertise in HTML, CSS, and JavaScript.
          <br />
           I craft engaging interfaces that deliver a seamless browsing 
          <br />
           experience across different devices and platforms.
        </span>
        <a href={Resume} download>
          <button className="button s-button">Download CV</button>
        </a>
        <div className="blur s-blur1" style={{ background: "#ABF1FF94" }}></div>
      </div>
      {/* right */}
      <div className="cards">
        {/* first card */}
        <motion.div
          initial={{ left: "25rem" }}
          whileInView={{ left: "14rem" }}
          transition={transition}
        >
          <Card
            emoji={HeartEmoji}
            heading={" Responsive Design"}
            detail={"I ensure that all websites I develop are responsive and adapt seamlessly to various screen sizes, from desktop computers to smartphones and tablets. This guarantees that users can access and interact with the site effortlessly, regardless of the device they are using."}
          />
        </motion.div>
        {/* second card */}
        <motion.div
          initial={{ left: "-11rem", top: "12rem" }}
          whileInView={{ left: "-4rem" }}
          transition={transition}
        >
          <Card
            emoji={Glasses}
            heading={"Customization & Scalability"}
            detail={"I understand that every business has its own brand identity and requirements. I work closely with clients to create websites that reflect their vision and goals, offering a customized and scalable solution that can grow with their business."}
          />
        </motion.div>
        {/* 3rd */}
        <motion.div
          initial={{ top: "19rem", left: "25rem" }}
          whileInView={{ left: "12rem" }}
          transition={transition}
        >
          <Card
            emoji={Humble}
            heading={"Performance Optimization"}
            detail={
              "I am committed to building high-performing websites that load quickly and provide a smooth user experience. Through optimization techniques such as minification, caching, and image optimization, I ensure that websites are optimized for speed and efficiency."
            }
            color="rgba(252, 166, 31, 0.45)"
          />
        </motion.div>
        <div
          className="blur s-blur2"
          style={{ background: "var(--purple)" }}
        ></div>
      </div>
    </div>
  );
};

export default Services;
